import React from "react";
import { RISK } from "../lib/constants";

export const RiskBadge = ({ level, size = "md" }) => {
  const r = RISK[level] || { label: "—", color: "#64748B", bg: "#F1F5F9" };
  const sizes = {
    sm: "text-xs px-2 py-0.5",
    md: "text-sm px-2.5 py-1",
    lg: "text-base px-3 py-1.5",
  };
  return (
    <span
      data-testid={`risk-badge-${level || "none"}`}
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold ${sizes[size]}`}
      style={{ background: r.bg, color: r.color }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: r.color }} />
      {r.label}
    </span>
  );
};
